"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileServiceV2Impl = void 0;
const WeProfileFacade_1 = require("./WeProfileFacade");
class ProfileServiceV2Impl {
    constructor(authService, stage) {
        this.authService = authService;
        this.weProfileFacade = new WeProfileFacade_1.WeProfileFacade(this.authService, stage);
    }
    async isUserProfileComplete() {
        const userProfile = await this.getUserProfile();
        return (userProfile !== undefined &&
            this.isNotBlank(userProfile.firstName) &&
            this.isNotBlank(userProfile.lastName) &&
            ['SALUTATION:MR', 'SALUTATION:MRS', 'SALUTATION:MS', undefined].some((s) => s === userProfile.salutation));
    }
    async getUserProfile() {
        const personalDataResponse = await this.weProfileFacade.get('personalData');
        return this.convertPersonalDataResponse(personalDataResponse);
    }
    async getMBBStatusData() {
        return await this.weProfileFacade.get('mbbStatusData');
    }
    async updateUserProfile(salutation, firstName, lastName) {
        const patchOperations = [];
        if (salutation) {
            patchOperations.push({ op: 'replace', path: '/salutation', value: salutation });
        }
        else {
            patchOperations.push({ op: 'remove', path: '/salutation' });
        }
        patchOperations.push({ op: 'replace', path: '/firstName', value: firstName }, { op: 'replace', path: '/lastName', value: lastName });
        return this.weProfileFacade.patch('personalData', patchOperations);
    }
    isNotBlank(value) {
        return !!(value && value.trim());
    }
    convertPersonalDataResponse(responseData) {
        const { addresses, phoneNumbers } = responseData, rest = __rest(responseData, ["addresses", "phoneNumbers"]);
        const primaryPhoneNumber = phoneNumbers && phoneNumbers.find((phoneNumber) => phoneNumber.primary === true);
        return Object.assign(Object.assign({}, rest), { address: addresses && addresses.find((address) => address.primary === true), phoneNumber: primaryPhoneNumber && primaryPhoneNumber.number });
    }
}
exports.ProfileServiceV2Impl = ProfileServiceV2Impl;
//# sourceMappingURL=ProfileServiceV2.js.map